import types from './types';

export default {
  isAuthenticated: (state) => () => {
    return !!state.idToken;
  },
  authStatus: (state) => () => {
    return state.status;
  },
  loggedIn: (state) => () => {
    // console.log('getters loggedIn');
    // console.dir(state.session);
    const session = state.session;
    const isValid = session && session.isValid()
    // console.log(isValid);
    return isValid;
  },
  sessionFound: (state) => () => {
    return !!state.session;
  },
  sessionValid: (state) => () => {
    return state.session && state.session.isValid()
  },
  getRegisterStatus: (state) => () => {
    return state.register.status;
  },
  getCodesStatus: (state) => () => {
    return state.codes.status;
  },
  [types.getters.GET_CODES]: (state) => () => {
    return state.codes.data;
  },
  [types.getters.IS_ADMIN]: (state) => () => {
    const groups = state.cognitoGroups || [];
    console.log('isAdmin getter', groups);

    return groups.includes('Admin') || groups.includes('Root');
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js